/*
 * Public API Surface of List Item Tag
 */

export * from './list-item-tag.component';
export * from './list-item-tag.module';
